import dayjs from 'dayjs'
import { logout } from '@/store/account'

export async function res2json(r) {
  if (r.status === 401) {
    logout()
    document.location.reload()
    return
  }
  r.data = await r.json()
  return r
}

export const expiresDays = (unixepoch) => Math.max(Math.ceil(dayjs(unixepoch * 1000).diff(new Date, 'h') / 24), 0)
